import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-900">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-4xl font-heading font-bold text-white mb-4">
          准备好开始阅读了吗？
        </h2>
        <p className="text-foreground-400 text-sm md:text-base max-w-xl mx-auto mb-8 leading-relaxed">
          加入h漫画，发现更多精彩内容。日系、国产、韩漫，总有一款适合你。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/japanese"
            className="px-8 py-3 bg-primary-500 hover:bg-primary-600 text-white rounded-md text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            立即开始阅读
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 bg-white/10 hover:bg-white/20 text-white rounded-md text-sm font-medium transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            了解平台
          </Link>
        </div>
      </div>
    </section>
  );
}